import { useState, useEffect } from "react";
import "../CSS/saami_tradestar_logistics_ilms.css";
//import ConsignmentBooking from "./ConsignmentBooking";

import api from "../api";
import useDraggableScroll from "../hooks/useDraggableScroll";
import Branch from "./Master/Branch";
import ConsignmentBooking from "./Booking/ConsignmentBooking";
import MobileVersion from "./Booking/MobileVersion";

import Party from "./Master/Party/Party_Master";
import Rate from "./Master/RateDefinition";
import ManifestInscan from "./Manifest/Manifest_Inscan";
import ManifestOutscan from "./Manifest/Manifest_Outscan";
import PartyInvoice from "./Transaction/PartyInvoice";
import GlobalSearch from "./Manifest/GlobalSearch";
import ExpClaims from "../Components/Expense/Claims";
import Approval from "../Components/Expense/Approval";
import Notification_Configuration from "../Components/System/Configuration";
import DrsPreparation from "./DRS/DrsPreparation";
// import Claims from "./Expense/Claims";
import DrsUpdation from "./DRS/DrsUpdation";
import AreaMaster from "./Master/AreaMaster";
import BillList from "./Reports/BillList";
import Barcodelabel from "./Reports/Barcodelabel";
import Additionalbill from "./Transaction/Additionalbill";
import ReportDefinition from "./Reports/ReportDefinition";
import JobMaster from "./Master/Jobmaster";
import UserMaster from "./System/Usermaster";
import RoleMaster from "./System/Rolemaster";
import { RightsProvider } from "../Components/RightsContext";
import CustomerCareCRM from "./Ticket/CustomerCareCRM";
import CompanyLogo from "./Logo";
import OperatorProductivityReport from "./Reports/OperatorProductivityReport";
// import ConsignmentRateUpdate from "./Master/ConsignmentRateUpdate";
import ConsignmentRateUpdate from "./Master/ConsignmentRateUpdate";
import EmployeeMaster from "./Master/EmployeeMaster";
import ReportViewer from "../Components/Reports/ReportViewer";
import ExpenseEntry from "./Expense/Expenseentry";
import DeliveryUpdate from "./MobileVersion/DeliveryUpdate";
import PodUpload from "../Components/MobileVersion/PodUpload";
import DashboardReport from "../Components/MIS/DashboardReport";
import SchedulerSettings  from "../Components/System/SchedulerSettings";
/* Screens that render edge-to-edge (no padding on <main>) */
const NO_PADDING_LEAVES = [
  "Fully Version", "Branch", "Party Master", "Rate", "Inscan", "Outscan", "Global",
  "Drs Preparation", "DRS Updation", "Normal Invoice", "Claims", "Claim Approval",
  "Configuration", "Bill List", "Barcodelabel", "Additional Bill", "Area",
  "Report Definition", "Job Master", "User Master", "Role Master", "Booking",
  "Customer Care", "CompanyLogo", "Operator Productivity Report",
  "Consignment Rate Update", "Employee Master", "Report Viewer",
  "Expense Entry", "Delivery", "POD Upload", "Dashboard", "Scheduler Settings",
];

/* ─── DATA ──────────────────────────────────────────────── */
const KPI_DATA = [
  { label: "Total Shipments", value: "1,482", delta: "▲ 12.4% vs last month", up: true, icon: "📦", accent: "var(--accent)" },
  { label: "In Transit", value: "38", delta: "▲ 5 active routes", up: true, icon: "🚛", accent: "var(--accent2)" },
  { label: "On-Time Delivery", value: "94%", delta: "▲ 2.1% this week", up: true, icon: "✅", accent: "var(--success)" },
  { label: "Revenue (PKR)", value: "8.4M", delta: "▲ 18.6% vs last month", up: true, icon: "💰", accent: "var(--warn)" },
  { label: "Pending Clearance", value: "7", delta: "▼ Needs attention", up: false, icon: "⚠️", accent: "var(--danger)" },
];

const SHIPMENTS = [
  { no: "01", date: "10 Apr 2026", consignment: "STL-240401", bookDest: "Karachi", delDest: "Lahore", job: "Al-Habib Textiles", pkgs: 24, wt: "320 kg", svc: "Express", svcColor: "var(--accent2)", status: "In Transit", sc: "s-transit", pod: true, pod2: true },
  { no: "02", date: "11 Apr 2026", consignment: "STL-240398", bookDest: "Multan", delDest: "Faisalabad", job: "PakOil Corp.", pkgs: 8, wt: "1,200 kg", svc: "Standard", svcColor: "var(--success)", status: "Delivered", sc: "s-delivered", pod: false, pod2: false },
  { no: "03", date: "11 Apr 2026", consignment: "STL-240403", bookDest: "Sukkur", delDest: "Islamabad", job: "Saifi Rice Mills", pkgs: 60, wt: "3,600 kg", svc: "Freight", svcColor: "var(--warn)", status: "In Transit", sc: "s-transit", pod: true, pod2: true },
  { no: "04", date: "12 Apr 2026", consignment: "STL-240405", bookDest: "Karachi Port", delDest: "Hyderabad", job: "Gul Ahmed Ltd.", pkgs: 1, wt: "5,800 kg", svc: "Container", svcColor: "var(--danger)", status: "Customs Hold", sc: "s-held", pod: null, pod2: null },
  { no: "05", date: "12 Apr 2026", consignment: "STL-240406", bookDest: "Lahore", delDest: "Peshawar", job: "Habib Metro", pkgs: 14, wt: "210 kg", svc: "Express", svcColor: "var(--accent2)", status: "Pending", sc: "s-pending", pod: null, pod2: null },
  { no: "06", date: "13 Apr 2026", consignment: "STL-240407", bookDest: "Rawalpindi", delDest: "Quetta", job: "National Foods", pkgs: 48, wt: "960 kg", svc: "Standard", svcColor: "var(--success)", status: "In Transit", sc: "s-transit", pod: true, pod2: null },
];

const ROUTES = [
  { name: "Karachi → Lahore", count: 342, pct: 100, color: "var(--accent)" },
  { name: "Karachi → Islamabad", count: 218, pct: 64, color: "var(--accent2)" },
  { name: "Lahore → Faisalabad", count: 189, pct: 55, color: "var(--success)" },
  { name: "Multan → Quetta", count: 112, pct: 33, color: "var(--warn)" },
  { name: "Sukkur → Peshawar", count: 76, pct: 22, color: "var(--muted)" },
];

const ACTIVITY = [
  { color: "var(--success)", msg: <><strong>STL-240398</strong> delivered to Faisalabad depot.</>, time: "Today, 08:44 · Driver: Usman Khan" },
  { color: "var(--accent)", msg: <><strong>STL-240401</strong> crossed Hyderabad checkpoint.</>, time: "Today, 07:22 · GPS Update" },
  { color: "var(--danger)", msg: <><strong>STL-240405</strong> flagged at Karachi Port Customs.</>, time: "Today, 06:15 · Requires action" },
  { color: "var(--accent2)", msg: <>New shipment <strong>STL-240407</strong> dispatched.</>, time: "Yesterday, 22:30 · Rawalpindi Hub" },
  { color: "var(--warn)", msg: <>Invoice <strong>#INV-1140</strong> overdue — Habib Metro.</>, time: "Yesterday, 18:00 · Finance Alert" },
];

/* ─── SUB-COMPONENTS ────────────────────────────────────── */

function NavLeaf({ label, activeLeaf, onLeafClick }) {
  const isActive = activeLeaf === label;
  return (
    <span
      className={`nav-leaf${isActive ? " active" : ""}`}
      onClick={() => onLeafClick(label)}
    >
      {label}
    </span>
  );
}

function NavSubGroup({ item, activeLeaf, onLeafClick }) {
  const [open, setOpen] = useState(!!item.defaultOpen);
  return (
    <>
      <div
        className={`nav-sub-parent${open ? " open" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`nav-sub-arrow${open ? " open" : ""}`}>▶</span>
      </div>
      <div className={`nav-sub-submenu${open ? " open" : ""}`}>
        {(item.subchildren || []).map(c => (
          <NavLeaf
            key={c.label}
            label={c.label}
            activeLeaf={activeLeaf}
            onLeafClick={onLeafClick}
          />
        ))}
      </div>
    </>
  );
}

function NavGroup({ item, openId, onToggle, activeLeaf, onLeafClick }) {
  const isOpen = openId === item.id;

  if (item.noChildren) {
    return (
      <div className="nav-group">
        <div
          className={`nav-parent${isOpen ? " active" : ""}`}
          onClick={() => onToggle(item.id)}
        >
          <span className="nav-icon-el">
            {item.icon && item.icon.includes("fa-") ? (
              <i className={item.icon}></i>
            ) : (
              item.icon
            )}
          </span>
          <span className="nav-label">{item.label}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="nav-group">
      <div
        className={`nav-parent${isOpen ? " open" : ""}`}
        onClick={() => onToggle(item.id)}
      >
        <span className="nav-icon-el">
          {item.icon && item.icon.includes("fa-") ? (
            <i className={item.icon}></i>
          ) : (
            item.icon
          )}
        </span>
        <span className="nav-label">{item.label}</span>
        <span className={`nav-arrow${isOpen ? " open" : ""}`}>▶</span>
      </div>
      <div className={`nav-submenu${isOpen ? " open" : ""}`}>
        {item.children.map(child =>
          child.isGroup
            ? (
              <NavSubGroup
                key={child.label}
                item={child}
                activeLeaf={activeLeaf}
                onLeafClick={onLeafClick}
              />
            )
            : (
              <span
                key={child.label}
                className={`nav-subitem${activeLeaf === child.label ? " active" : ""}`}
                onClick={() => onLeafClick(child.label)}
              >
                {child.label}
              </span>
            )
        )}
      </div>
    </div>
  );
}

function StatusBadge({ sc, label }) {
  return <span className={`badge-status ${sc}`}>{label}</span>;
}

function PodBtn({ available, done }) {
  if (available === null)
    return <span style={{ color: "var(--muted)", fontSize: 11 }}>—</span>;
  if (done === false)
    return (
      <button
        className="action-btn"
        style={{ color: "var(--success)", borderColor: "var(--success)" }}
      >
        ✓ Done
      </button>
    );
  return <button className="action-btn">📄 View</button>;
}

/* ─── DYNAMIC RIGHTS CHECKER ────────────────────────────── */
const checkDashboardRights = (menuData) => {
  if (!Array.isArray(menuData)) return false;
  for (const module of menuData) {
    if (!module.children) continue;
    for (const child of module.children) {
      const label = (child.label || "").toLowerCase().trim();
      const path = (child.pathname || "").toLowerCase().trim();
      if (label.includes("dashboard") || path.includes("dashboard")) {
        return true;
      }
      if (child.subchildren && Array.isArray(child.subchildren)) {
        for (const sub of child.subchildren) {
          const subLabel = (sub.label || "").toLowerCase().trim();
          const subPath = (sub.pathname || "").toLowerCase().trim();
          if (subLabel.includes("dashboard") || subPath.includes("dashboard")) {
            return true;
          }
        }
      }
    }
  }
  return false;
};

/* ─── MAIN COMPONENT ────────────────────────────────────── */
export default function SaamiTradestarLogistics({ logoutUser }) {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 900);
  const [openMenu, setOpenMenu] = useState(() => sessionStorage.getItem("openMenu") || "master");
  const [activeLeaf, setActiveLeaf] = useState(() => sessionStorage.getItem("activeLeaf") || "CHECK_RIGHTS");
  const [activeTab, setActiveTab] = useState("All");
  const [showLogout, setShowLogout] = useState(false);
  const [navMenu, setNavMenu] = useState([]); // Dynamic menu state
  const [loadingMenu, setLoadingMenu] = useState(true);

  useEffect(() => {
    fetchMenu();

    // Auto-collapse sidebar on resize for better responsiveness
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    const handlePageShow = (event) => {
      if (event.persisted) {
        sessionStorage.setItem("activeLeaf", "CHECK_RIGHTS");
        fetchMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("pageshow", handlePageShow);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const fetchMenu = async () => {
    try {
      const res = await api.get("/sidebar");
      const menuData = res.data || [];
      setNavMenu(menuData);

      const hasDashboardAccess = checkDashboardRights(menuData);
      const currentLeaf = sessionStorage.getItem("activeLeaf") || "CHECK_RIGHTS";

      if (currentLeaf === "CHECK_RIGHTS" || currentLeaf === "CompanyLogo" || currentLeaf === "Dashboard") {
        if (hasDashboardAccess) {
          setActiveLeaf("Dashboard");
          sessionStorage.setItem("activeLeaf", "Dashboard");
        } else {
          setActiveLeaf("CompanyLogo");
          sessionStorage.setItem("activeLeaf", "CompanyLogo");
        }
      }
    } catch (error) {
      console.error("Failed to fetch sidebar menu:", error);
      setNavMenu([]);
      setActiveLeaf("CompanyLogo");
      sessionStorage.setItem("activeLeaf", "CompanyLogo");
    } finally {
      setLoadingMenu(false);
    }
  };
  const username = sessionStorage.getItem("username") || "Ahmed Raza";
  const initials = username.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);

  const handleLogout = async () => {
    try {
      await api.post("/api/Login/logout"); // Call backend logout
    } catch (error) {
      console.warn("Logout request failed, cleaning local session anyway.", error);
    }
    logoutUser(); // Clear localStorage and redirect to login
  };

  const handleMenuToggle = (id) => {
    setOpenMenu(prev => {
      const newVal = prev === id ? null : id;
      if (newVal) sessionStorage.setItem("openMenu", newVal);
      else sessionStorage.removeItem("openMenu");
      return newVal;
    });
  };

  const handleLeafClick = (label) => {
    setActiveLeaf(label);
    sessionStorage.setItem("activeLeaf", label);
    if (window.innerWidth <= 900) setSidebarOpen(false);
  };

  const tableRef = useDraggableScroll();

  const filteredShipments = activeTab === "All"
    ? SHIPMENTS
    : SHIPMENTS.filter(s =>
      activeTab === "In Transit" ? s.sc === "s-transit"
        : activeTab === "Delivered" ? s.sc === "s-delivered"
          : s.sc === "s-pending" || s.sc === "s-held"
    );

  return (
    <>
      <RightsProvider>

        <div className={`app-shell${!sidebarOpen ? " sidebar-collapsed" : ""}`}>

          {/* ══ SIDEBAR ══ */}
          <nav className={`sidebar${sidebarOpen ? " open" : ""}`}>
            <div className="logo-wrap">
              <div className="logo-row">
                <div className="logo-icon">🚚</div>
                <div className="logo-text">
                  <div className="logo-name">SAAMI TRADESTAR</div>
                  <div className="logo-sub">Logistics Ltd</div>
                </div>
              </div>
              <div className="ilms-band">
                <div className="ilms-band-name">ILMS</div>
                <div className="ilms-band-full">Innovative Logistics Management System</div>
              </div>
            </div>

            <div className="nav-section">
              {loadingMenu ? (
                <div style={{ padding: "20px", color: "var(--muted)", fontSize: "12px" }}>Loading menu…</div>
              ) : navMenu.length > 0 ? (
                navMenu.map(item => (
                  <NavGroup
                    key={item.id}
                    item={item}
                    openId={openMenu}
                    onToggle={handleMenuToggle}
                    activeLeaf={activeLeaf}
                    onLeafClick={handleLeafClick}
                  />
                ))
              ) : (
                <div style={{ padding: "20px", color: "var(--muted)", fontSize: "12px" }}>No menu items found</div>
              )}
            </div>

            <div className="sidebar-footer">
              <div className="user-card">
                <div
                  className="avatar"
                  style={{ cursor: "pointer", position: "relative" }}
                  onClick={() => setShowLogout(!showLogout)}
                >
                  {initials}
                  {showLogout && (
                    <div className="logout-dropdown">
                      <button onClick={handleLogout}>🚪 Logout</button>
                    </div>
                  )}
                </div>
                <div className="user-info" style={{ flex: 1, overflow: "hidden" }}>
                  <div className="user-name">{username}</div>
                  <div className="user-role">Operations Manager</div>
                </div>
                <span
                  className="user-more"
                  style={{ color: "var(--muted)", fontSize: 13, cursor: "pointer" }}
                  onClick={() => setShowLogout(!showLogout)}
                >
                  ⋯
                </span>
              </div>
            </div>
          </nav>

          {/* ══ HEADER ══ */}
          <header className="ilms-header">
            <div className="header-left">
              <button className="hamburger" onClick={() => setSidebarOpen(o => !o)}>☰</button>
              <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
                <span style={{ fontFamily: "var(--font-head)", fontWeight: 800, fontSize: 17, letterSpacing: ".06em", color: "var(--accent)" }}>
                  ILMS
                </span>
                <span
                  className="ilms-full"
                  style={{ fontSize: 9, fontWeight: 600, letterSpacing: ".07em", color: "var(--muted)", textTransform: "uppercase", whiteSpace: "nowrap" }}
                >
                  Innovative Logistics Management System
                </span>
              </div>
            </div>
            <div className="header-right">
              <div
                className="avatar"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={() => setShowLogout(!showLogout)}
              >
                {initials}
                {showLogout && (
                  <div className="logout-dropdown header-logout">
                    <button onClick={handleLogout}>🚪 Logout</button>
                  </div>
                )}
              </div>
            </div>
          </header>

          <main className="main" style={NO_PADDING_LEAVES.includes(activeLeaf) ? { padding: 0 } : {}}>
            {activeLeaf === "Fully Version" ? (
              <ConsignmentBooking variant="full" />
            ) : activeLeaf === "Branch" ? (
              <Branch />
            ) : activeLeaf === "Booking" ? (
              <MobileVersion />
            ) : activeLeaf === "Party Master" ? (
              <Party />
            ) : activeLeaf === "Rate" ? (
              <Rate />
            ) : activeLeaf === "Inscan" ? (
              <ManifestInscan />
            ) : activeLeaf === "Outscan" ? (
              <ManifestOutscan />
            ) : activeLeaf === "Global Search" ? (
              <GlobalSearch />
            ) : activeLeaf === "Drs Preparation" ? (
              <DrsPreparation />
            ) : activeLeaf === "DRS Updation" ? (
              <DrsUpdation />
            ) : activeLeaf === "Normal Invoice" ? (
              <PartyInvoice />
            ) : activeLeaf === "Barcode Label" ? (
              <Barcodelabel />
            ) :
              activeLeaf === "Claims" ? (
                <ExpClaims />
              ) : activeLeaf === "Claim Approval" ? (
                <Approval />
              ) : activeLeaf === "Configuration" ? (
                <Notification_Configuration />
              ) : activeLeaf === "Bill List" ? (
                <BillList />
              ) : activeLeaf === "Additional Bill" ? (
                <Additionalbill />
              ) : activeLeaf === "Area" ? (
                <AreaMaster />
              ) : activeLeaf === "Report Definition" ? (
                <ReportDefinition />
              ) : activeLeaf === "Job Master" ? (
                <JobMaster />
              ) : activeLeaf === "User Master" ? (
                <UserMaster />
              ) : activeLeaf === "Role Master" ? (
                <RoleMaster />
              ) : activeLeaf === "Customer Care" ? (
                <CustomerCareCRM />
              ) : (activeLeaf === "CompanyLogo" || activeLeaf === "Company Logo") ? (
                <DashboardReport />
              ) : activeLeaf === "Operator Productivity" ? (
                <OperatorProductivityReport />
              ) : activeLeaf === "Consignment Rate Update" ? (
                <ConsignmentRateUpdate />
              ) : activeLeaf === "Report Viewer" ? (
                <ReportViewer />
              ) : activeLeaf === "Employee Master" ? (
                <EmployeeMaster />
              ) : activeLeaf === "Expense Entry" ? (
                <ExpenseEntry />
              ) :
                activeLeaf === "Delivery" ? (
                  <DeliveryUpdate />
                ) :
                  activeLeaf === "POD Upload" ? (
                    <PodUpload />
                  ) : activeLeaf === "Dashboard" ? (
                    <DashboardReport />
                  ) : activeLeaf === "Schedular Setting" ? (
                    <SchedulerSettings />
                  ) : (
                    <>
                      {/* Page Header */}
                      <div className="page-header">
                        <div>
                          <div className="page-title">Operations <span>Dashboard</span></div>
                          <div className="page-sub">Tuesday, 14 April 2026 &nbsp;·&nbsp; Karachi Hub</div>
                        </div>
                        <div className="btn-group">
                          <button className="btn btn-outline">⬇ Export</button>
                          <button className="btn btn-primary">+ New Shipment</button>
                        </div>
                      </div>

                      {/* KPI Strip */}
                      <div className="kpi-grid">
                        {KPI_DATA.map((k, i) => (
                          <div key={i} className="kpi-card" style={{ "--card-accent": k.accent }}>
                            <style>{`.kpi-card:nth-child(${i + 1})::after { background: ${k.accent}; }`}</style>
                            <div className="kpi-label">{k.label}</div>
                            <div className="kpi-value">{k.value}</div>
                            <div className={`kpi-delta ${k.up ? "kpi-up" : "kpi-dn"}`}>{k.delta}</div>
                            <div className="kpi-icon-bg">{k.icon}</div>
                          </div>
                        ))}
                      </div>

                      {/* Active Shipment Report */}
                      <div>
                        <div className="section-header">
                          <div className="section-title">Active Shipment Report</div>
                          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                            <div className="tab-pills">
                              {["All", "In Transit", "Delivered", "Pending"].map(tab => (
                                <div
                                  key={tab}
                                  className={`pill${activeTab === tab ? " active" : ""}`}
                                  onClick={() => setActiveTab(tab)}
                                >
                                  {tab}
                                </div>
                              ))}
                            </div>
                            <button className="btn btn-outline" style={{ fontSize: 12, padding: "6px 12px" }}>⬇ CSV</button>
                            <button className="btn btn-outline" style={{ fontSize: 12, padding: "6px 12px" }}>🖨 Print</button>
                          </div>
                        </div>

                        <div className="table-wrap">
                          <div className="table-toolbar">
                            {["📅 Booking Date", "📍 Booking Dest.", "🏁 Delivery Dest.", "👤 Job Name", "🔖 Services"].map(f => (
                              <div key={f} className="filter-input">{f}</div>
                            ))}
                            <div style={{ marginLeft: "auto", fontSize: 12, color: "var(--muted)" }}>
                              Showing <strong style={{ color: "var(--text)" }}>{filteredShipments.length}</strong> of 142
                            </div>
                          </div>

                          <div className="tbl-scroll" ref={tableRef}>
                            <table>
                              <thead>
                                <tr>
                                  <th style={{ width: 40 }}>No.</th>
                                  <th>Booking Date</th>
                                  <th>Consignment No</th>
                                  <th>Booking Dest.</th>
                                  <th>Delivery Dest.</th>
                                  <th>Job Name</th>
                                  <th style={{ textAlign: "center" }}>No. of Pkg</th>
                                  <th style={{ textAlign: "center" }}>Weight</th>
                                  <th>Services</th>
                                  <th>Delivery Status</th>
                                  <th style={{ textAlign: "center" }}>POD</th>
                                  <th style={{ textAlign: "center" }}>POD 2</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredShipments.map(s => (
                                  <tr key={s.consignment}>
                                    <td style={{ color: "var(--muted)", fontSize: 12 }}>{s.no}</td>
                                    <td><span style={{ fontFamily: "var(--font-mono)", fontSize: 11 }}>{s.date}</span></td>
                                    <td><span className="ship-id">{s.consignment}</span></td>
                                    <td>{s.bookDest}</td>
                                    <td>{s.delDest}</td>
                                    <td>{s.job}</td>
                                    <td style={{ textAlign: "center" }}>{s.pkgs}</td>
                                    <td style={{ textAlign: "center", fontFamily: "var(--font-mono)", fontSize: 12 }}>{s.wt}</td>
                                    <td>
                                      <span style={{
                                        background: `color-mix(in srgb, ${s.svcColor} 15%, transparent)`,
                                        color: s.svcColor,
                                        padding: "2px 8px",
                                        borderRadius: 10,
                                        fontSize: 11,
                                        fontWeight: 600,
                                      }}>
                                        {s.svc}
                                      </span>
                                    </td>
                                    <td><StatusBadge sc={s.sc} label={s.status} /></td>
                                    <td style={{ textAlign: "center" }}>
                                      <PodBtn available={s.pod} done={s.sc === "s-delivered" ? false : null} />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <PodBtn available={s.pod2} done={s.sc === "s-delivered" ? false : null} />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          <div className="pagination-bar">
                            <span>Page 1 of 24</span>
                            <div style={{ display: "flex", gap: 4 }}>
                              {["‹ Prev", "1", "2", "3", "…", "24", "Next ›"].map((p, i) => (
                                <button
                                  key={i}
                                  className="action-btn"
                                  style={p === "1" ? { borderColor: "var(--accent)", color: "var(--accent)" } : {}}
                                >
                                  {p}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Analytics Row */}
                      <div className="analytics-row">

                        {/* Donut */}
                        <div className="stat-panel">
                          <div className="stat-panel-title">Shipment Status Breakdown</div>
                          <div className="donut-wrap">
                            <svg width="90" height="90" viewBox="0 0 90 90">
                              <circle cx="45" cy="45" r="35" fill="none" stroke="var(--panel)" strokeWidth="12" />
                              <circle cx="45" cy="45" r="35" fill="none" stroke="var(--accent2)" strokeWidth="12" strokeDasharray="87.96 131.95" strokeDashoffset="0" transform="rotate(-90 45 45)" />
                              <circle cx="45" cy="45" r="35" fill="none" stroke="var(--success)" strokeWidth="12" strokeDasharray="83.56 131.95" strokeDashoffset="-87.96" transform="rotate(-90 45 45)" />
                              <circle cx="45" cy="45" r="35" fill="none" stroke="var(--warn)" strokeWidth="12" strokeDasharray="30.79 131.95" strokeDashoffset="-171.52" transform="rotate(-90 45 45)" />
                              <circle cx="45" cy="45" r="35" fill="none" stroke="var(--danger)" strokeWidth="12" strokeDasharray="17.59 131.95" strokeDashoffset="-202.31" transform="rotate(-90 45 45)" />
                              <text x="45" y="49" textAnchor="middle" fill="var(--text)" fontSize="13" fontFamily="Barlow Condensed" fontWeight="700">1,482</text>
                            </svg>
                            <div className="donut-legend">
                              {[
                                ["var(--accent2)", "In Transit", "40%"],
                                ["var(--success)", "Delivered", "38%"],
                                ["var(--warn)", "Pending", "14%"],
                                ["var(--danger)", "Held", "8%"],
                              ].map(([c, l, p]) => (
                                <div key={l} className="legend-row">
                                  <div className="legend-col" style={{ background: c }} />
                                  {l}
                                  <span className="legend-pct">{p}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Top Routes */}
                        <div className="stat-panel">
                          <div className="stat-panel-title">Top Routes by Volume</div>
                          <div className="bar-list">
                            {ROUTES.map(r => (
                              <div key={r.name} className="bar-row">
                                <div className="bar-lbl">
                                  <span>{r.name}</span>
                                  <span className="bar-lbl-val">{r.count}</span>
                                </div>
                                <div className="bar-track">
                                  <div className="bar-fill" style={{ width: `${r.pct}%`, background: r.color }} />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Recent Activity */}
                        <div className="stat-panel" style={{ padding: 0, overflow: "hidden" }}>
                          <div style={{ padding: "16px 18px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <span style={{ fontFamily: "var(--font-head)", fontWeight: 700, fontSize: 15 }}>Recent Activity</span>
                            <span style={{ fontSize: 11, color: "var(--accent2)", cursor: "pointer" }}>View all</span>
                          </div>
                          <div>
                            {ACTIVITY.map((a, i) => (
                              <div key={i} className="activity-item">
                                <div className="a-dot" style={{ background: a.color }} />
                                <div>
                                  <div className="a-msg">{a.msg}</div>
                                  <div className="a-time">{a.time}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                      </div>

                    </>
                  )}

            {/* Persistent Footer */}
            <footer className="page-footer" style={{ marginTop: "auto", paddingBottom: 0 }}>
              <span>© 2026 <strong style={{ color: "var(--text)" }}>Saami Tradestar Logistics Ltd</strong> &nbsp;·&nbsp; ILMS v2.4.1</span>
              <div style={{ display: "flex", gap: 16 }}>
                <a href="#">Privacy Policy</a>
                <a href="#">Support</a>
                <a href="#">v2.4.1</a>
              </div>
            </footer>
          </main>
        </div>
      </RightsProvider>
    </>
  );
}
